import { render, staticRenderFns } from "./PlatformCustomer.vue?vue&type=template&id=848a5408&scoped=true"
import script from "./PlatformCustomer.vue?vue&type=script&lang=js"
export * from "./PlatformCustomer.vue?vue&type=script&lang=js"
import style0 from "./PlatformCustomer.vue?vue&type=style&index=0&id=848a5408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848a5408",
  null
  
)

export default component.exports